<fc-search-input
  [label]="'LOCATIONS_GROUPS_INPUT.TITLE' | translate"
  [control]="control"
  [search]="search"
  [displayWith]="displayWith"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
  [translateErrorPrefix]="translateErrorPrefix"
  [enableInfiniteScroll]="enableInfiniteScroll"
></fc-search-input>
